
import React from 'react';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';

import { deshabilitarVehiculo } from '../../../services/vehiculosService';
import './deshabilitar-vehiculo.css';

const DeshabilitarVehiculo = ({ id_vehiculo, onSuccess, showToast }) => {
  
  const accept = async () => {
    try {
      const payload = { id_vehiculo };

      const deshabilitar =  await deshabilitarVehiculo(payload);

      if (deshabilitar?.ok === false || !deshabilitar) {
        throw new Error('No se pudo deshabilitar el vehículo');
      }

      showToast({ severity: 'success', summary: 'Exito', detail: 'Vehículo deshabilitado correctamente', life: 4500 });

      if (onSuccess) onSuccess();
    }
    catch (error) {
      showToast({ severity: 'error', summary: 'Error', detail: error, life: 4500 });
    }
  }

  const reject = () => {
    showToast({ severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada', life: 4500 });
  }

  const confirmacion = () => {
    confirmDialog({
      message: '¿Está seguro de que desea deshabilitar el vehículo seleccionado?',
      header: 'Deshabilitar Vehículo',
      icon: 'pi pi-ban',
      defaultFocus: 'reject',
      rejectLabel: 'Cancelar',
      acceptLabel: 'Deshabilitar',
      acceptClassName: 'p-confirm-dialog-accept',
      rejectClassName: 'p-confirm-dialog-reject',
      className: 'deshabilitar-veh',
      accept,
      reject
    });
  }

  return (
    <>
      <ConfirmDialog className= 'deshabilitar-veh'/>

      <Button 
        type="button"
        icon="pi pi-ban"
        label="Deshabilitar Vehículo"
        className="btn btn-outline-danger"
        onClick={confirmacion}
      />
    </>
  )
}

export default DeshabilitarVehiculo